import axios from "axios";

export default function getAnalyticsSla({ dateFrom = "", dateTo = "" }) {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/analytics/sla", {
        params: { date_from: dateFrom, date_to: dateTo },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
